var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStop = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0.875C6.75195 0.875 0.875 6.75195 0.875 14C0.875 21.248 6.75195 27.125 14 27.125C21.248 27.125 27.125 21.248 27.125 14C27.125 6.75195 21.248 0.875 14 0.875ZM14 24.8984C7.98242 24.8984 3.10156 20.0176 3.10156 14C3.10156 11.3926 4.01855 8.99609 5.54785 7.12109L20.8789 22.4521C19.0039 23.9814 16.6074 24.8984 14 24.8984ZM22.4521 20.8789L7.12109 5.54785C8.99609 4.01855 11.3926 3.10156 14 3.10156C20.0176 3.10156 24.8984 7.98242 24.8984 14C24.8984 16.6074 23.9814 19.0039 22.4521 20.8789Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStop);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/stop.ca710a46b94cc2bf9e6ef585f8c4409d.svg";